if (!customElements.get('pdp-carousel-recommendations')) {
  class PdpCarouselRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.loadRecommendations();
    }

    async loadRecommendations() {
      const productId = this.dataset.productId;
      const limit = this.dataset.limit || '10';
      const intent = this.dataset.intent || 'related';
      const cardType = this.dataset.productCardType || 'default';
      const sectionId = cardType === 'simple' ? 'pdp_carousel_recommendations_simple' : 'pdp_carousel_recommendations_default';
      const slider = this.querySelector('.keen-slider');
      const carousel = this.querySelector('component-carousel');
      if (!productId || !slider || typeof routes === 'undefined' || !routes.product_recommendations_url) {
        return;
      }

      const url = routes.product_recommendations_url + `?product_id=${productId}&limit=${limit}&section_id=${sectionId}&intent=${intent}`;
      const data = await $s.getDataFromUrls([url]);
      const text = data[url];
      if (!text || text.indexOf('keen-slider-slide') === -1) {
        return;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const slides = [];
      doc.querySelectorAll('.keen-slider-slide').forEach((slide) => {
        slides.push(slide.outerHTML);
      });
      if (slides.length === 0) {
        return;
      }

      slider.innerHTML = slides.join('');
      slider.querySelectorAll('.product-card').forEach((card) => {
        if (this.dataset.cardsColorScheme) {
          card.classList.add('scheme', ...this.dataset.cardsColorScheme.split(' '));
        }
        if (this.dataset.cardsColorScheme === this.dataset.contentColorScheme) {
          card.classList.add('same-scheme-true');
          card.classList.remove('same-scheme-false');
        } else {
          card.classList.add('same-scheme-false');
          card.classList.remove('same-scheme-true');
        }
      });

      this.style.display = '';
      $s.globalEval(this);
      requestAnimationFrame(() => {
        if (carousel && typeof carousel.initSlider === 'function') {
          carousel.initSlider();
        }
        const slider = this.querySelector('.keen-slider');
        if (slider) {
          slider.dispatchEvent(new Event('keen.created'));
        }
        $s.dispatchEvent(this, 'pdp-carousel-recommendations:show');
      });
    }
  }
  customElements.define('pdp-carousel-recommendations', PdpCarouselRecommendations);
}
